import { createContainer } from 'unstated-next';
import { getExtClass } from '@/services/report-library';
import { useFetch } from '@/hooks';

function useReportClassification() {
  const { data, error, refresh } = useFetch(() => getExtClass());

  return {
    reportClassificationData: data,
    error,
    refresh,
  };
}

const ReportClassification = createContainer(useReportClassification);

export default ReportClassification;
